import { z } from "zod";

export enum UserRole {
	Developer = "Developer",
	CompanyAdmin = "Company Admin",
	BranchManager = "Branch Manager",
	RVP = "RVP",
	Nurse = "Nurse",
	PRN = "PRN",
	Client = "Client",
	Caregiver = "Caregiver",
	TrustedContact = "Trusted Contact",
}

export const UserRoleDisplayName = {
	1: "Branch Manager",
	2: "Company Admin",
	3: "Caregiver",
	4: "Developer",
	5: "Nurse",
	6: "RVP",
	7: "PRN",
};

export const UserRoleOptions = Object.entries(UserRoleDisplayName).map(
	([key, value]) => ({
		value: key,
		label: value,
		disabled: key.toString() === "4" || key.toString() === "3",
	}),
);

//@TODO deprecate this model
export const UserRoleSchema = z.object({
	id: z.number(),
	role: z.nativeEnum(UserRole),
	pgRole: z.string().default("crm_default"),
	hasSystemLevelAccess: z.boolean().default(false),
	hasCompanyLevelAccess: z.boolean().default(false),
	hasBranchLevelAccess: z.boolean().default(false),
	hasPayPeriodLockOverride: z.boolean().default(false),
	chatEnabled: z.boolean().default(false),
	chatBroadcastEnabled: z.boolean().default(false),
	chatBroadcastAllEnabled: z.boolean().default(false),
	chatSendMessageEnabled: z.boolean().default(false),
	chatDownloadAttachmentEnabled: z.boolean().default(false),
	chatUploadAttachmentEnabled: z.boolean().default(false),
	chatInitiateConversationEnabled: z.boolean().default(false),
	chatCopyAttachmentsEnabled: z.boolean().default(false),
	chatReadBranchConversationsEnabled: z.boolean().default(false),
});

export type UserRoleType = z.infer<typeof UserRoleSchema>;
